import { NgModule } from '@angular/core';
import { AuthGuard } from './auth.guard';
import { IfAuthorizedDirective } from './auth.directives';
import { Configuration } from '../configuration';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';

@NgModule({
    declarations: [
        IfAuthorizedDirective
    ],
    exports: [
        IfAuthorizedDirective
    ],
    providers: [
        AuthService,
        AuthGuard,
        JwtHelperService,
        Configuration
    ]
})
export class AuthModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/auth/auth.module.ts